import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import classnames from 'classnames';

import { getTrialIcon } from '#entities';
import { EResourceStatus, type ENOPOrganType } from '#shared';

import { CellDrawerCounts } from './CellDrawerCounts';
import { cellDrawerClasses } from './CellDrawerRoot';

import type { DeviceResource } from '#entities';

type Props = {
  day: 'today' | 'tomorrow';
  resources: DeviceResource[];
  selectedOrgan: ENOPOrganType;
};

export const CellDeviceDrawerContent = ({
  resources,
  selectedOrgan,
}: Props) => {
  const [assigned, available] = resources.reduce<
    [DeviceResource[], DeviceResource[]]
  >(
    (acc, resource) => {
      const [assignedAcc, availableAcc] = acc;
      if (resource.unosId) {
        assignedAcc.push(resource);
      } else {
        availableAcc.push(resource);
      }
      return acc;
    },
    [[], []],
  );

  return (
    <Box className={cellDrawerClasses.resourceTableContainer}>
      <CellDrawerCounts
        assignedCount={assigned.length}
        availableCount={available.length}
      />
      {resources.length > 0 && (
        <Table className={cellDrawerClasses.deviceResources}>
          <TableHead>
            <TableRow>
              <TableCell className={cellDrawerClasses.resourceName}>
                Device
              </TableCell>
              <TableCell className={cellDrawerClasses.resourceSerialNumber}>
                Serial No
              </TableCell>
              <TableCell className={cellDrawerClasses.resourceAssignedTo}>
                Assigned to
              </TableCell>
              <TableCell className={cellDrawerClasses.resourceTrial}>
                Trial Cert
              </TableCell>
              <TableCell className={cellDrawerClasses.resourceStatus}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {resources.map((resource, index) => {
              const TrialIcon = resource.trialProgram
                ? getTrialIcon(resource.trialProgram.name)
                : null;

              return (
                <TableRow
                  key={resource.serialNumber}
                  className={(index % 2 && 'even') || 'odd'}
                >
                  <TableCell className={cellDrawerClasses.resourceName}>
                    {resource.name}
                  </TableCell>
                  <TableCell className={cellDrawerClasses.resourceSerialNumber}>
                    {resource.serialNumber}
                  </TableCell>
                  <TableCell
                    className={classnames(
                      cellDrawerClasses.resourceAssignedTo,
                      `organ-type-${selectedOrgan}`,
                    )}
                  >
                    {resource.unosId}
                  </TableCell>
                  <TableCell className={cellDrawerClasses.resourceTrial}>
                    {TrialIcon && <TrialIcon />}
                  </TableCell>
                  <TableCell className={cellDrawerClasses.resourceStatus}>
                    <span
                      className={classnames(cellDrawerClasses.resourceStatus, {
                        [cellDrawerClasses.assigned]:
                          resource.status === EResourceStatus.Assigned,
                        [cellDrawerClasses.available]:
                          resource.status === EResourceStatus.Available,
                      })}
                    >
                      {resource.status}
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};
